import { Link } from 'react-router-dom';
import EditableImage from '@/components/base/EditableImage';

export default function CTASection() {
  return (
    <section className="relative h-[500px] md:h-[600px] lg:h-[700px] w-full overflow-hidden">
      <EditableImage
        imageKey="cta-bg"
        src="https://storage.readdy-site.link/project_files/f92c80ae-33f0-4a14-8b33-f39c30020a16/e26f629c-0875-4ffe-8e16-59bb62b36b96_IMG_0605.png?v=fd6d309d43e0ef3e8a827df46e578444"
        alt="Evento elegante"
        containerClassName="absolute inset-0 w-full h-full"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 h-full flex flex-col justify-between items-start px-6 md:px-10 lg:px-16 py-16 md:py-20 lg:py-24">
        <div className="max-w-3xl pt-4 md:pt-6 lg:pt-8">
          <h2 className="font-serif text-[1.75rem] md:text-3xl lg:text-4xl text-white font-medium leading-[1.3] tracking-wide">
            Seu momento merece ser lembrado
            <br />
            <span className="italic font-normal text-[2rem] md:text-[3.25rem] lg:text-[4.5rem] leading-[1.1] block mt-1 md:mt-2">
              para sempre.
            </span>
            <br />
            <span className="italic font-normal text-lg md:text-2xl lg:text-3xl opacity-80">
              Vamos conversar?
            </span>
          </h2>
        </div>

        <div className="flex flex-col items-center gap-3 pb-4 md:pb-6 lg:pb-8">
          <Link
            to="/contato"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white text-dark text-sm font-semibold hover:bg-warm-100 transition-all duration-300 whitespace-nowrap"
          >
            Solicitar Orçamento
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-dark text-white">
              <i className="ri-arrow-right-line text-sm" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}